import getApi from '../../../api/apisauceConfig'
import { ServerSentNotification } from '../../../model/Notification'
import { ServerSentNotificationMutationPayload } from './notification.model'

export const postNotification = (payload: ServerSentNotificationMutationPayload) =>
  getApi().post<ServerSentNotification>('/admin/notifications', payload)
